import type { CTNumFmt } from '../model-pb/ct-num-fmt-sml';
import { NUMBER_FORMAT_TYPE } from '../number-format-type';

interface IFormatTypeResult {
    group: NUMBER_FORMAT_TYPE;
    type: NUMBER_FORMAT_TYPE | 'numeral' | 'exponential';
}

/**
 * 给定数值格式或格式码, 判断格式类型
 * 如不传入参数则返回默认格式
 */
function getNumberFormatType(numberFormat: CTNumFmt | string | undefined | null): IFormatTypeResult {
    // 目前 slide 里面反格式化不传入 numberFormat
    // if (numberFormat === null || numberFormat === undefined) {
    return {
        group: NUMBER_FORMAT_TYPE.GENERAL,
        type: NUMBER_FORMAT_TYPE.GENERAL,
    };
    // }
}

export {
    IFormatTypeResult,
    getNumberFormatType,
};
